import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { HoloPanel } from "../components/HoloPanel";
import { api, apiBase } from "../lib/api";

export default function LoginPage() {
  const [ready, setReady] = useState(null);
  const error = new URLSearchParams(window.location.search).get("errore");
  useEffect(() => {
    api.get("/auth/config").then(({ data }) => setReady(data.google_ready)).catch(() => setReady(false));
  }, []);

  return (
    <div className="app-frame login-frame" data-testid="login-page">
      <header className="top-bar"><span className="wordmark" data-testid="login-wordmark">LUCHADOR</span><span className="login-header-status">ACCESSO RISERVATO</span></header>
      <main className="login-main">
        <div className="login-orb" aria-hidden="true" />
        <div className="login-intro"><span className="section-label">YOLLO · RETE COMMERCIALE</span><h1 data-testid="login-heading">Benvenuto in<br /><strong>Luchador.</strong></h1></div>
        <HoloPanel className="login-panel" testId="login-panel">
          <span className="panel-label">IDENTIFICAZIONE</span>
          <p data-testid="login-instruction">Accedi con il tuo account Google autorizzato.</p>
          {error && <p className="login-error" role="alert" data-testid="login-error">{error === "non-autorizzato" ? "Accesso non autorizzato" : "Accesso Google non riuscito. Riprova."}</p>}
          <Button className="hud-button google-button" disabled={!ready} onClick={() => { window.location.href = `${apiBase}/auth/google/start`; }} data-testid="google-login-button">
            <span className="google-g" aria-hidden="true">G</span> Accedi con Google
          </Button>
          {ready === false && <p className="config-notice" data-testid="google-config-notice">Accesso Google non ancora configurato.</p>}
        </HoloPanel>
      </main>
      <footer className="login-footer" data-testid="login-footer">LUCHADOR CRM <span>◆</span> YOLLO</footer>
    </div>
  );
}